import { useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { CLASSROOM_ROUTES } from '@/shared/constants/routes';
import { cn } from '@/utils/tailwind.util';
import { openClassroomTab } from '../utils';
const SUPPORTED_NO_CLASS_IMAGE_LOCALES = ['en', 'id', 'ja', 'ko', 'th'] as const;
export function CreateClassroomImageButton({
  className,
  onBeforeOpenClassroom
}: {
  className?: string;
  onBeforeOpenClassroom?: () => void;
}) {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['common']);
  const language = locale.split('-')[0];
  const imageLocale = SUPPORTED_NO_CLASS_IMAGE_LOCALES.includes(language as (typeof SUPPORTED_NO_CLASS_IMAGE_LOCALES)[number]) ? language : 'en';
  const imageBasePath = '/assets/classroom/share-modal';
  return <button type="button" aria-label={t('common:classroomLink.createClassroomButton')} onClick={() => {
    onBeforeOpenClassroom?.();
    openClassroomTab(CLASSROOM_ROUTES.list());
  }} className={cn('block aspect-[388/123] w-full overflow-hidden rounded-md border border-opacity-assistive bg-default text-left transition-opacity hover:opacity-90 mobile-lg:aspect-auto mobile-lg:h-[491px] mobile-lg:w-[198px]', className)} data-sentry-component="CreateClassroomImageButton" data-sentry-source-file="CreateClassroomImageButton.tsx">
      <picture data-sentry-element="picture" data-sentry-source-file="CreateClassroomImageButton.tsx">
        <source media="(min-width: 560px)" srcSet={`${imageBasePath}/no-class-pc-${imageLocale}.webp`} />
        <img src={`${imageBasePath}/no-class-${imageLocale}.webp`} alt="" className="h-full w-full object-cover" />
      </picture>
    </button>;
}